import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { KILO } from '../../constants/KILO_THEME'

export function CollapsedDisclaimer() {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)

  return (
    <div className="mt-2">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="flex w-full items-center gap-2 text-left"
        aria-expanded={expanded}
      >
        <div className="flex h-[14px] w-[14px] shrink-0 items-center justify-center rounded-full border border-neutral-400 dark:border-neutral-700">
          <span className="text-[9px] text-neutral-400 dark:text-neutral-600">ⓘ</span>
        </div>
        <p className="text-[10px] text-neutral-500 dark:text-neutral-600">
          {t('workout.debrief.collapsedDisclaimerSummary')}
        </p>
      </button>
      {expanded ? (
        <div className="mt-2 rounded-xl border border-kilo-line bg-kilo-nested p-3">
          <p className={`mb-2 text-[10px] leading-relaxed ${KILO.text.muted}`}>
            {t('workout.debrief.collapsedDisclaimerAi')}
          </p>
          <p className="text-[10px] leading-relaxed text-neutral-500 dark:text-neutral-600">
            {t('workout.debrief.collapsedDisclaimerWellness')}
          </p>
        </div>
      ) : null}
    </div>
  )
}

export default CollapsedDisclaimer
